export default "__VITE_ASSET__52a5c431__"